import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

const containerHeight = 190;
const footerHeight = 32;
const listHeight = containerHeight - footerHeight;

export const SearchSelectContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}));

export const SearchSelectBodyContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  height: `${containerHeight}px`,
  alignItems: "flex-start",
  alignSelf: "stretch",
  borderRadius: "8px",
  border: `1px solid ${colors.gray300}`,
  background: colors.gray25,
}));

export const SearchItemContainer = styled("div")(() => ({
  display: "flex",
  gap: "8px",
  alignItems: "center",
  alignSelf: "stretch",
  padding: "3px 0px",
  "& .MuiIconButton-label span": {
    width: "14px !important",
    height: "14px !important",
    "&::before": {
      width: "14px !important",
      height: "14px !important",
    },
  },
}));

export const SearchItemContainerFooter = styled("div")(() => ({
  display: "flex",
  width: "100%",
  padding: "0px 8px",
  justifyContent: "space-between",
  alignItems: "flex-start",
  height: `${footerHeight}px`,
  borderTop: `1px solid ${colors.gray300}`,
}));

export const SearchItemListContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  alignItems: "center",
  alignSelf: "stretch",
  height: `${listHeight}px`,
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "5px",
    backgroundColor: colors.gray100,
    border: "none",
  },
  margin: "12px 12px 0px 12px",
}));

export const SearchItemLabel = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
}));

interface SearchItemContainerFooterButtonProps {
  disabled?: boolean;
}

export const SearchItemContainerFooterButton = styled("div")(
  ({ disabled }: SearchItemContainerFooterButtonProps) => ({
    color: disabled ? colors.gray400 : colors.blue500,
    cursor: disabled ? "not-allowed" : "pointer",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
    padding: "10px",
    height: "32px",
  })
);
